export const tplENG = '<table class="tip-content-table" style="width:100%" cellpadding="0" cellspacing="0">' +
    '<tr>' +
        '<th>boothCode:</th><td>{code}</td>' +
    '</tr>' +
    '<tr>' +
        '<th>boothName:</th><td>{fullname}</td>' +
    '</tr>' +
    '<tr>' +
        '<th>boothType:</th><td>{boothType}</td>' +
    '</tr>' +
    '<tr>' +
        '<th>entryType:</th><td>{entryType}</td>' +
    '</tr>' +
    '<tr>' +
        '<th>lateralLength:</th><td>{lateralLength}</td>' +
    '</tr>' +
    '<tr>' +
        '<th>verticalLength:</th><td>{verticalLength}</td>' +
    '</tr>' +
    '<tr>' +
        '<th>area:</th><td>{area}</td>' +
    '</tr>' +
'</table>'



// WEBPACK FOOTER //
// ./src/components/ploter/businessShape/tipTplENG.js